import React, { useEffect, useState } from 'react';
import './TourModule.css';

const TOUR_KEY = 'spinwin_tour_hidden';

const steps = [
  {
    target: '#tour-coin-picker',
    title: 'Select Your Stake',
    content: 'Start by choosing the chip value you want to bet. Tap to select different chip sizes.',
    placement: 'top'
  },
  {
    target: '#tour-bet-tray',
    title: 'Place Your Bet',
    content: 'Tap on any of the betting tiles to place your chips. You can bet on multiple tiles to increase your chances!',
    placement: 'bottom'
  },
  {
    target: '#tour-spin-btn',
    title: 'Spin The Wheel',
    content: 'Once your bets are placed, tap this button to spin the wheel and reveal your prize! If you previously bet, you can tap it to quick-Rebet.',
    placement: 'top'
  },
  {
    target: '#tour-drawer-btn',
    title: 'More Options',
    content: 'Access the menu to repeat previous bets, double your stake, or start an automated Autoplay session.',
    placement: 'top'
  },
  {
    target: '#tour-info-btn',
    title: 'Game Info',
    content: 'Tap here at any time to open the info model, view game rules, check your limits, and adjust your wheel speed.',
    placement: 'bottom'
  }
];

export function TourModule({ isOpen, onClose, tutorialStatus, onUpdateStatus }) {
  const [currentStep, setCurrentStep] = useState(0);
  const [targetRect, setTargetRect] = useState(null);
  const [dontShow, setDontShow] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setDontShow(!!tutorialStatus);
    }
  }, [isOpen, tutorialStatus]);

  useEffect(() => {
    if (!isOpen) {
      setCurrentStep(0);
      setTargetRect(null);
      return;
    }

    let rafId;
    let currentTarget = null;

    const trackRect = () => {
      const step = steps[currentStep];
      const targetElement = document.querySelector(step.target);
      
      if (targetElement) {
        currentTarget = targetElement;
        targetElement.classList.add('tour-highlighted-element');
        
        const rect = targetElement.getBoundingClientRect();
        setTargetRect(prevRect => {
          if (!prevRect ||
              prevRect.top !== rect.top ||
              prevRect.left !== rect.left ||
              prevRect.width !== rect.width ||
              prevRect.height !== rect.height) {
            return rect;
          }
          return prevRect;
        });
      } else {
        setTargetRect(null);
      }
      rafId = requestAnimationFrame(trackRect);
    };

    // Initial delay so any entrance animations can settle
    const t = setTimeout(() => {
      rafId = requestAnimationFrame(trackRect);
    }, 150);
    
    return () => {
      clearTimeout(t);
      cancelAnimationFrame(rafId);
      if (currentTarget) {
        currentTarget.classList.remove('tour-highlighted-element');
      }
      document.querySelectorAll('.tour-highlighted-element').forEach(el => {
        el.classList.remove('tour-highlighted-element');
      });
    };
  }, [isOpen, currentStep]);

  if (!isOpen) return null;

  const handleClose = () => {
    if (dontShow !== tutorialStatus) {
      onUpdateStatus?.(dontShow);
    }
    onClose();
  };

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(prev => prev + 1);
    } else {
      handleClose();
    }
  };

  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(prev => prev - 1);
    }
  };

  let popoverStyle = { 
    position: 'fixed', 
    top: '50%', 
    left: '50%', 
    transform: 'translate(-50%, -50%)' 
  };

  if (targetRect) {
    const isTopHalf = targetRect.top < window.innerHeight / 2;
    if (isTopHalf) {
      popoverStyle = { 
        position: 'fixed', 
        top: Math.min(targetRect.bottom + 10, window.innerHeight - 200), 
        left: '50%', 
        transform: 'translateX(-50%)' 
      };
    } else {
      popoverStyle = { 
        position: 'fixed', 
        bottom: Math.max(window.innerHeight - targetRect.top + 20, 20), 
        left: '50%', 
        transform: 'translateX(-50%)' 
      };
    }
  }

  return (
    <div className="tour-overlay">
      {targetRect && (
        <div 
          className="tour-hole"
          style={{
            top: targetRect.top - 8,
            left: targetRect.left - 8,
            width: targetRect.width + 16,
            height: targetRect.height + 16
          }}
        />
      )}
      
      <div className="tour-popover" style={popoverStyle}>
        <div className="tour-badge">Step {currentStep + 1} of {steps.length}</div>
        <h3 className="tour-title">{steps[currentStep].title}</h3>
        <p className="tour-content">{steps[currentStep].content}</p>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
          <label className="tour-checkbox">
            <input
              type="checkbox"
              checked={dontShow}
              onChange={(event) => setDontShow(event.target.checked)}
            />
            <span>Don&apos;t show again</span>
          </label>
          </div>
          <button className="tour-btn tour-btn-skip" onClick={handleClose}>Skip</button>

        </div>
        <div className="tour-footer mt-2">
         
        
          <div className="tour-controls">
            {currentStep > 0 && (
              <button className="tour-btn tour-btn-prev" onClick={handlePrev}>Back</button>
            )}
            <button className="tour-btn tour-btn-next" onClick={handleNext}>
              {currentStep === steps.length - 1 ? 'Finish' : 'Next'}
            </button>
          </div>
        </div>
        <div className="tour-dot-footer">
          <div className="tour-dots">
            {steps.map((_, i) => (
              <span key={i} className={`tour-dot ${i === currentStep ? 'active' : ''}`} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
